import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LookUpDialogService {
  private findParameters = new Subject<any>();
  private selectedValue = new Subject<any>();
  lookupSelectedValue = new Subject<any>();

  constructor() { }
  /**
   * 1. Receives find parameters from find form
   * 2. Sets the findParameters observable 
   * @param parameters from find form as key value pairs
   */
  setFindParameters(parameters):void{
    this.findParameters.next(parameters);
  }
  /**
   * 
   * @returns parameters to be used in the search
   */
  getFindParameters():Observable<any>{
    return this.findParameters.asObservable();
  }
  /**
   * 1. Receives data emitted from the onRowSelect function in the list
   * 2. Data contains row data
   * 3. Set the selected value observable
   * @param data 
   */
  setSelectedRow(data):void{
    this.selectedValue.next(data);
  }
  /**
   * 
   * @returns selectedValue (row) as observable
   */
  getSelectedRow():Observable<any>{
    return this.selectedValue.asObservable();
  }

  setLookupSelectedValue(data):void{
    this.lookupSelectedValue.next(data);
  }

  getLookupSelectedValue():Observable<any>{
    return this.lookupSelectedValue.asObservable()
  }
}
